module.exports = __webpack_public_path__ + "static/media/accueil.1c72d09b.svg";